<template>
  <div class="nuttrema-input-edit-in-place">
    <input
       type="text"
       class="inline-edit"
       v-model="options.value"
      :disabled="disabled"
      :placeholder="placeholder"
      @focusout="onFocusOut">
  </div>
</template>

<script>
export default {
  name: 'nuttrema-input-edit-in-place',
  props: {
    name: {
      required: true,
      default: null,
    },
    value: {
      required: true,
      default: null,
    },
    params: {
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      options: {
        value: this.value,
      },
    };
  },
  methods: {
    onFocusOut() {
      const changed = this.value !== this.options.value;
      if (changed) {
        this.$emit('edited', {
          name: this.name,
          value: this.options.value,
          params: this.params,
        });
      }
    },
  },
  watch: {
    value(value) {
      this.options.value = value;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  .nuttrema-input-edit-in-place {
    width: 100%;

    /* Make an input blend into its parent */
    input.inline-edit{
      width: 100%;

      /* Eliminate borders and padding */
      border: none;
      padding: 0;
      margin: 0;

      /* Inherit the parent element's typography */
      font: inherit;
      color: inherit;
      line-height: inherit;
      font-size: inherit;
      text-align: inherit;

      outline: none;

      /* Seems to help alignment in headers */
      vertical-align: top;

      text-overflow: ellipsis;
    }

    /* Add interaction cues on hover and focus */
    input.inline-edit:focus {
      /* Change the background to a light yellow */
      background-color: #FFD;

      /* A subtle transition never hurts */
      -webkit-transition: background-color 0.5s;
         -moz-transition: background-color 0.5s;
          -ie-transition: background-color 0.5s;
              transition: background-color 0.5s;
    }

    &.ttl {
      font-size: 1.15rem;
      font-weight: 500;
    }

    &.note {
      font-size: 1rem;
      color: $gray-light;
    }

    &.is-transparent {
      background-color: transparent;
      input {
        background-color: transparent;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/input/nuttrema-input-edit-in-place.vue